export const TIERS = [
  { max: 100000,  price: 0.15, label: 'Early Bird' },
  { max: 200000,  price: 0.25, label: 'Tier 2' },
  { max: 350000,  price: 0.40, label: 'Tier 3' },
  { max: 500000,  price: 0.65, label: 'Tier 4' },
  { max: 650000,  price: 1.00, label: 'Tier 5' },
  { max: 800000,  price: 1.75, label: 'Tier 6' },
  { max: 900000,  price: 2.50, label: 'Tier 7' },
  { max: 1000000, price: 4.00, label: 'Final' },
];

export const getPricePerPixel = (currentPixelsSold) => {
  const tier = TIERS.find(t => currentPixelsSold <= t.max);
  return tier ? tier.price : 4.00;
};

export const getNextTierInfo = (currentPixelsSold) => {
  const currentTierIndex = TIERS.findIndex(t => currentPixelsSold <= t.max);
  if (currentTierIndex === -1 || currentTierIndex === TIERS.length - 1) return null;
  const currentTier = TIERS[currentTierIndex];
  const nextTier = TIERS[currentTierIndex + 1];
  return {
    remaining: currentTier.max - currentPixelsSold,
    nextPrice: nextTier.price,
  };
};

export const getTierNumber = (currentPixelsSold) => {
  return TIERS.findIndex(t => currentPixelsSold <= t.max) + 1;
};

export const getCurrentTier = (currentPixelsSold) => {
  return TIERS.find(t => currentPixelsSold <= t.max) || TIERS[TIERS.length - 1];
};